/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/harmful-mistake'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import HarmfulMistake from '@routes/StaticPages/HarmfulMistake';

export const Route = createFileRoute('/harmful-mistake')({
  component: () => (
    <CacheDataRoute component={HarmfulMistake} path='/harmful-mistake' />
  )
});
